//--------------------------------------------------------------------------------
/**
 * Foreshortens the text if it is too long, adding '...' to the end and optionally trimming 
 * from the start instead of end
 */
export function foreshorten(text: string | undefined, maxLength: number, trimFromEnd?: boolean) {
    if (!text) return text;
    if (maxLength < 4) maxLength = 4;
    if (text.length <= maxLength) return text;
    if (trimFromEnd) {
        return '...' + text.substring(text.length - maxLength + 3);
    } else {
        return text.substring(0, maxLength - 3) + '...';
    }
}
